import { operatorClient } from 'domain/HttpClients';

// termId, ...otherFilters
export const fetch = (filters, headers) => {
  const { id, ...otherFilters } = filters;
  return operatorClient
    .Get(`/api/finance/credit-terms/${id}/transactions`)
    .withParams(otherFilters)
    .send();
};
